export default {
  "discountRules.createRule": "割引規則を作成する",
  "discountRules.createTitle": "割引規則作成",
  "discountRules.editTitle": "割引規則編集",
  "discountRules.setting": "割引規則設定",
  "discountRules.simultaneousPurchase": "同時購入割引",
  "discountRules.applicableNumber": "適用本数",
  "discountRules.applicableDay": "当日のみ適用",
  "discountRules.boxOffice": "興行収入へ反映",
  "discountRules.couponCombination": "優待券/引換券併用",
  "discountRules.nationalCouponCombination": "全国共通券併用",
  "discountRules.case": "本目の場合",
  "discountRules.amount": "割引額（円）",
  "discountRules.free": "無料",
  "discountRules.plsInputName": "名前を入力してください",
  "discountRules.plsInputQty": "適用本数を入力してください",
  "discountRules.qty.less.validate": "適用本数少なくとも2つ",
  "discountRules.qty.more.validate": "適用本数最大10",
};
